
<template>
    <div>
    {{ checkModal }}
    <component v-if="isAttach" :is="isAttach" :type="attachType" @remove ="attachCloseModal" @attachFile ="attachFile"></component>
    <b-modal v-model="modalShow" ref="my-modal" hide-footer title="Добавление фотографии">
    <div class="row">
              <div class="attech_tab_items">
                  <b-form-file v-if="upPhoto == null"
              :multiple = "Boolean(true)"
              accept="image/*"
      v-model="file1"
      @change="uploadFile"
      :state="Boolean(file1)"
      :placeholder="'Нажмите или перетащите фотографии'"
      drop-placeholder="Отпустите файл..."
    ></b-form-file>
    <div  v-else class="modal_attfile_prew">
    <div v-for="(photo, index) in fArray" :key="'p'+index"  class="modal_attfile_prew_item">
      <div  class="att_controls">
                    <button class="icon delete" @click="removePhoto(index)" title="Удалить">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 19a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" fill="#3a494e"/></svg>
                    </button>
                  </div>
              <img :src="photo" alt="" v-image-viewer/>
    </div></div>
                
              </div>
              <div class="col-12" v-if="0 > 1">
                <div class="form-label mt-3 text-left photoUpload episode-fix">
                  <div class="dropdown" @click.privent="attachMedia('photo')">
                    <img v-if="upPhoto" id="photoUploadLenta" data-bs-toggle="dropdown" v-image-viewer aria-expanded="false" :src="upPhoto" />
          <svg v-if="!upPhoto" id="photoUploadLenta" data-bs-toggle="dropdown" aria-expanded="false" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 10C10.1046 10 11 9.10457 11 8C11 6.89543 10.1046 6 9 6C7.89543 6 7 6.89543 7 8C7 9.10457 7.89543 10 9 10Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M13 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H15C20 22 22 20 22 15V10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M18 8V2L20 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M18 2L16 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M2.66998 18.9501L7.59998 15.6401C8.38998 15.1101 9.52998 15.1701 10.24 15.7801L10.57 16.0701C11.35 16.7401 12.61 16.7401 13.39 16.0701L17.55 12.5001C18.33 11.8301 19.59 11.8301 20.37 12.5001L22 13.9001" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
       
      </div>
    
                 
    </div>
              </div>



              <div class="col-12">
                <div class="col-12 mb-2 mt-2" v-if="kinder_groups.length > 0">
    <select name="kinder_group" id="kinder_group" placeholder="Выберите группу" tabindex="-1" class="selectized" style="display: none;">
  <option value="0" selected="selected">Без группы</option></select>
  <v-selectize v-model="kinder_group" :options="kinder_groups" key-by="id" label="name"/>
      </div>
                <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" v-model="pdesc" placeholder="Введите описание.."></textarea>
        </div>
        
    </div>
    <button class="btn btn-primary btn-block ml-auto mt-3" @click.prevent="createEpisode" type="submit">Добавить</button>

	
</b-modal>
    
    </div> 
        </template>
        
        <script>
        import Attach from '../media/Attach.vue';
        import { BModal } from 'bootstrap-vue'
        import VSelectize from '@isneezy/vue-selectize'
        export default {
            components: { BModal, Attach, VSelectize },
           name: 'Episode',
           props: ['kinder_groups', 'platform'],
            data(){
            return {
              file1: null,
               kinder_group: {id: '0', name: 'Выберите группу'},
                modalShow: true,
                pdesc: null,
                upPhoto: null,
                fArray: {},
                isAttach: null,
                attachType: 'photo'
            }
           },
           mounted(){
           },
           methods: {
            removePhoto(index) {
                // Удаляем один элемент по индексу
              const confirmed = window.confirm('Вы уверены, что хотите удалить это фото?');
    if (confirmed) {
      this.fArray.splice(index, 1);
    }
    if(this.fArray.length <= 0){
      this.upPhoto = null
    }
            },
            uploadFile(event){
              this.$bvToast.toast('Загружаем изображение..', { title: 'Система', variant: 'warning', visible: true });  
              this.uploadImage(event, 'upload')
            },
            uploadImage(event, type = 'lenta') {
           const files = event.target.files
          if (!files || files.length === 0){
            this.$bvToast.toast('Вы не выбрали изображение.', { title: 'Ошибка', variant: 'danger', visible: true });
              return this.file1 = null;
          } 
          if (files.length > 10){
            this.$bvToast.toast('Максимально 10 изображений.', { title: 'Ошибка', variant: 'danger', visible: true });
            return this.file1 = null;
          } 
  
    const URL = '/api/file.upload'; 
    let data = new FormData();
    data.append('loadtype', 'addcontent');
  files.forEach(file => {
    data.append('files[]', file);
  });
    axios.post(
      URL, 
      data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }
    ).then(
      response => {
        this.$bvToast.toast('Изображение(я) загружено(ы).', { title: 'Система', variant: 'success', visible: true });
          this.upPhoto = response.data[0];
          this.fArray = response.data;
      }).catch( error => {
    this.$bvToast.toast('Не удалось загрузить изображение', { title: 'Ошибка', variant: 'danger', visible: true })
  })
    },
            createEpisode(){
            if(this.upPhoto == null || typeof(this.upPhoto) == "undefined"){
              return this.$bvToast.toast('Вы не загрузили фотографию', {
          title: 'Ошибка',
          variant: 'danger',
          visible: true
        })
            }
                axios.post('/api/episode.create', {'pdesc': this.pdesc, 'photo': this.fArray, 'kinder_group': this.kinder_group}).then( res => {
                    this.modalShow = false
                this.$router.push({ name: 'episode.show', params: { 'id': res.data.id } })
            }).catch( error => {
                alert(error.response.data.message);
            })
            },
       attachMedia(type){
        this.attachType = type
        this.isAttach = 'Attach'
      },
      attachCloseModal(status) {
        this.isAttach = status
      },
      attachFile(files, type, name, ftype){
        this.upPhoto = files
        this.isAttach = null
      }
           },
           emits: ['remove'],
           computed: {
        checkModal() {
            if(!this.modalShow){
                this.$emit('remove', null)
            }
           
          return 
        }
      },
      beforeDestroy() {
    if (this.upPhoto) {
      this.upPhoto = null
      this.file1 = null
    }
  }
        }
        </script>
        
        <style scoped>
        .modal_attfile_prew_item{
             width: 32%;
    position: relative;
    background-color: #e5e5e5;
    border-radius: 10px;
    max-height: 150px;
    align-content: center;
        }
.modal_attfile_prew{
   width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    column-wrap: wrap;
    justify-content: center;
    gap: 16px;
}
          .att_controls { position: absolute; top:6px; right:6px; display:flex; gap:6px; z-index:5; }
.att_controls .icon { background: rgba(255,255,255,0.9); border-radius:6px; border: none; padding:4px; display:flex; align-items:center; justify-content:center; cursor: pointer; }
.att_controls .icon svg { display:block; }
       .attech_tab_items img{
              width: auto;
    max-height: 100%;
    max-width: 100%;
    margin: 0 auto;
    display: block;
    object-fit: contain;
        }
        </style>
        